import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../../common_components/mdae-framework";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { cloneDeepWith } from "lodash";
import { GET_TASK_GROUP_LIST } from "../../../user-management/task-groups/services/get-task-group-list";
import { GET_ACTIVE_USER_LIST_FOR_TASK_GROUP } from "../../../user-management/task-groups/services/get-active-user-list-for-task-group";
import { SET_TASK_GROUP_USER_EMAIL_PREFERENCE } from "../../../user-management/task-groups/services/set-task-group-user-email-preference";
export const TOGGLE_TASK_GROUP_POPUP = "TOGGLE_TASK_GROUP_POPUP";
export const SET_TASK_GROUP_FORM_DATA = "SET_TASK_GROUP_FORM_DATA";
export const RESET_TASK_GROUP_POPUP_VALIDATION =
  "RESET_TASK_GROUP_POPUP_VALIDATION";
export const TOGGLE_USER_TO_GROUP_POPUP = "TOGGLE_USER_TO_GROUP_POPUP";
export const SET_ADD_USER_TO_TASK_GROUP_LIST =
  "SET_ADD_USER_TO_TASK_GROUP_LIST";
export const SET_USER_ASSIGNED_TO_GROUP_LIST =
  "SET_USER_ASSIGNED_TO_GROUP_LIST";
export const TOGGLE_MOVE_USER_TO_GROUP_POPUP =
  "TOGGLE_MOVE_USER_TO_GROUP_POPUP";
export const SET_OTHER_USER_GROUP_LIST = "SET_OTHER_USER_GROUP_LIST";
export const RESET_USER_MOVE_TO_GROUP_POPUP_VALIDATION =
  "RESET_USER_MOVE_TO_GROUP_POPUP_VALIDATION";
export const TOGGLE_TASK_GROUP_LIST_ACTION_POPOVER =
  "TOGGLE_TASK_GROUP_LIST_ACTION_POPOVER";
export const SET_DAILY_DIGEST_TOGGLE_VALUE = "SET_DAILY_DIGEST_TOGGLE_VALUE";

export const defaultTaskGroupFormData = {
  taskGroupName: "",
  description: "",
  selectedUserIds: [],
  isAssignedUserListChanged: false,
  taskGroupId: 0,
  selectedUser: [],
};

const initialState = {
  taskGroupList: [],
  taskGroupFormData: { ...defaultTaskGroupFormData },
  userAssignedToTaskGroupList: [],
  selectedUser: [],
  isDailyDigestEnabled: true,
};
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TOGGLE_TASK_GROUP_POPUP:
    case TOGGLE_USER_TO_GROUP_POPUP:
    case RESET_TASK_GROUP_POPUP_VALIDATION:
    case SET_ADD_USER_TO_TASK_GROUP_LIST:
    case SET_USER_ASSIGNED_TO_GROUP_LIST:
    case TOGGLE_MOVE_USER_TO_GROUP_POPUP:
    case SET_OTHER_USER_GROUP_LIST:
    case RESET_USER_MOVE_TO_GROUP_POPUP_VALIDATION:
    case TOGGLE_TASK_GROUP_LIST_ACTION_POPOVER:
    case SET_DAILY_DIGEST_TOGGLE_VALUE:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(state, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_TASK_GROUP_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const taskGroupFormData = newState.taskGroupFormData
          ? newState.taskGroupFormData
          : {};
        for (let prop in action.data.taskGroupFormData) {
          taskGroupFormData[prop] = action.data.taskGroupFormData[prop];
        }
        newState = { ...newState, taskGroupFormData };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_TASK_GROUP_LIST)(action)) {
        return {
          ...state,
          taskGroupList: [],
        };
      }
      if (isAsyncComplete(GET_TASK_GROUP_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          taskGroupList: response.taskGroupList,
          isDailyDigestEnabled: response.isDailyDigestEnabled,
        };
      }
      if (isAsyncOperation(GET_ACTIVE_USER_LIST_FOR_TASK_GROUP)(action)) {
        return { ...state, userListForTaskGroup: [] };
      }
      if (isAsyncComplete(GET_ACTIVE_USER_LIST_FOR_TASK_GROUP)(action)) {
        const response = action.response;
        return {
          ...state,
          userListForTaskGroup: response.userList,
        };
      }
      if (isAsyncComplete(SET_TASK_GROUP_USER_EMAIL_PREFERENCE)(action)) {
        const response = action.response;
        return {
          ...state,
          isDailyDigestEnabled: response.isDailyDigestEnabled,
        };
      }
      return state;
    default:
      return state;
  }
};
